import { Pagination } from 'src/app/shared/interfaces/pagination';
import { PositionCustody } from 'src/app/shared/interfaces/position-custody';
import { formatComitenteDocument } from 'src/app/pages/register/register-confirmation/shared/register-confirmation-details.utils';

import { PositionCustodyFilter } from '../interfaces/position-custody-filter';

export function createPositionConsultPagination(size = 10): Pagination<PositionCustody> {
  return {
    page: 1,
    size,
    results: [],
  };
}

export function isEmptyValue(value: unknown): boolean {
  if (value === null || value === undefined) {
    return true;
  }

  if (typeof value === 'string') {
    return value.trim().length === 0;
  }

  if (value instanceof Date) {
    return Number.isNaN(value.getTime());
  }

  return false;
}

/** Conta filtros visíveis na UI (badge do botão Filtrar). */
export function countActiveFilters(filters: PositionCustodyFilter): number {
  let count = 0;

  if (!isEmptyValue(filters.positionDate)) {
    count++;
  }

  if (!isEmptyValue(filters.carbonCreditCode)) {
    count++;
  }

  if (!isEmptyValue(filters.projectId)) {
    count++;
  }

  if (!isEmptyValue(filters.accountCode)) {
    count++;
  }

  if (!isEmptyValue(filters.participantSimplifiedName)) {
    count++;
  }

  if (!isEmptyValue(filters.financialInstrumentCode)) {
    count++;
  }

  return count;
}

/**
 * Indica se há critério suficiente para chamar GET /custodies.
 * Qualquer campo basta — data NÃO é obrigatória.
 */
export function hasQueryableFilters(filters: PositionCustodyFilter): boolean {
  return !isEmptyValue(filters.positionDate)
    || !isEmptyValue(filters.accountCode)
    || !isEmptyValue(filters.carbonCreditCode)
    || !isEmptyValue(filters.projectId)
    || !isEmptyValue(filters.participantSimplifiedName)
    || !isEmptyValue(filters.financialInstrumentCode);
}

export function resolvePositionSerialLabel(position: PositionCustody): string {
  return displayPositionValue(position.serialRange ?? position.serialCode);
}

/**
 * Exibe comitente como veio do BE (regra N/A é do backend).
 * Normaliza "N/A" para o texto do Figma.
 */
export function resolvePositionComitenteLabel(position: PositionCustody): string {
  const raw = position.comitente ?? position.comitenteDocumentNumber;

  if (isEmptyValue(raw)) {
    return '-';
  }

  const value = String(raw).trim();
  if (value.toUpperCase() === 'N/A' || value.toLowerCase() === 'não aplicável') {
    return 'Não aplicável';
  }

  if (/^\d+$/.test(value.replace(/\D/g, '')) && value.replace(/\D/g, '').length >= 11) {
    return formatComitenteDocument(value);
  }

  return value;
}

export function displayPositionValue(value?: string | number | null): string {
  if (value === null || value === undefined || value === '') {
    return '-';
  }

  return String(value);
}
